export function isARBleEnabled(): boolean {
  return true;
}

export function isAROrgeEnabled(): boolean {
  /*    let roles : string[] = KeycloakService.auth.authz.tokenParsed.realm_access.roles;
    let setRoles : Set<string> = new Set<string>(roles);
    return setRoles.has('ROLE_ADMIN') || setRoles.has('ROLE_SECTOR');
*/
  return true;
}
